import { Link } from 'react-router-dom';
import { ROUTES } from '../../utils/index.js';
import './Home.css';

export const Home = () => {
  return (
    <div className="container-home">
      <section className="hero-home">
        <span className="badge-home">Service Intel - Postcards Marketing</span>
        <h1 className="title-home">Service Intel Postcards Marketing</h1>
        <p className="subtitle-home">
          Your all-in-one platform for creating and managing marketing postcard campaigns for auto repair shops.
        </p>
        <div className="cta-home">
          <Link to={ROUTES.DASHBOARD} className="btn-primary-home">
            Go to Dashboard
          </Link>
          <a href="#features" className="btn-outline-home">
            Learn More
          </a>
        </div>
      </section>

      <section className="highlights-home">
        <div className="highlight-item-home">
          <svg className="highlight-icon-home" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <circle cx="12" cy="12" r="6" />
            <circle cx="12" cy="12" r="2" />
          </svg>
          <span className="highlight-text-home">Radius-based Search</span>
        </div>
        <div className="highlight-divider-home" />
        <div className="highlight-item-home">
          <svg className="highlight-icon-home" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
          </svg>
          <span className="highlight-text-home">Excel & CSV Export</span>
        </div>
        <div className="highlight-divider-home" />
        <div className="highlight-item-home">
          <svg className="highlight-icon-home" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
          </svg>
          <span className="highlight-text-home">Batch Management</span>
        </div>
      </section>

      <section className="features-home" id="features">
        <h2 className="features-title-home">Why Choose Service Intel?</h2>
        <div className="features-grid-home">
          <div className="feature-card-home">
            <div className="feature-icon-wrap-home icon-blue-home">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="22" y1="2" x2="11" y2="13" />
                <polygon points="22 2 15 22 11 13 2 9 22 2" />
              </svg>
            </div>
            <h3 className="feature-title-home">Easy Campaign Creation</h3>
            <p className="feature-description-home">
              Design and launch postcard campaigns in minutes with our intuitive interface.
            </p>
          </div>
          <div className="feature-card-home">
            <div className="feature-icon-wrap-home icon-green-home">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="20" x2="18" y2="10" />
                <line x1="12" y1="20" x2="12" y2="4" />
                <line x1="6" y1="20" x2="6" y2="14" />
              </svg>
            </div>
            <h3 className="feature-title-home">Analytics & Insights</h3>
            <p className="feature-description-home">
              Track your campaign performance with detailed analytics and reports.
            </p>
          </div>
          <div className="feature-card-home">
            <div className="feature-icon-wrap-home icon-purple-home">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <circle cx="12" cy="12" r="6" />
                <circle cx="12" cy="12" r="2" />
              </svg>
            </div>
            <h3 className="feature-title-home">Targeted Marketing</h3>
            <p className="feature-description-home">
              Reach the right audience with our advanced targeting capabilities.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
